module.exports = __webpack_public_path__ + "img/CardNFT02.072b2498.png";